import { h } from 'preact';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import IconButton from '@mui/material/IconButton';

import { lazyList, UrlTable } from './_common.jsx';

import styles from '../../components/global.css';

export function LazyOverviewFormFactorCard(props) {
  const { sx } = props;

  return (
    <Card sx={{ ...(sx || {}) }}>
      <CardHeader title={<Skeleton width={80} />} />
      <CardContent>
        <Stack direction={'row'} justifyContent="space-between">
          <Stack
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Card sx={{ mr: 2 }} elevation={0} variant="outlined">
              <CardHeader
                subheader="CRUX grade"
                action={
                  <IconButton>
                    <Skeleton
                      sx={{ marginLeft: 'auto' }}
                      height={24}
                      width={24}
                      variant="circular"
                    />
                  </IconButton>
                }
              />
              <CardContent sx={{ paddingTop: 0 }}>
                <Typography variant="h4" className={''}>
                  <Skeleton width={60} />
                </Typography>
              </CardContent>
            </Card>

            <Card
              sx={{ marginRight: '16px !important;' }}
              elevation={0}
              variant="outlined"
            >
              <CardHeader
                subheader="Latest good UX"
                action={
                  <IconButton>
                    <Skeleton
                      sx={{ marginLeft: 'auto' }}
                      height={24}
                      width={24}
                      variant="circular"
                    />
                  </IconButton>
                }
              />
              <CardContent sx={{ paddingTop: 0 }}>
                <Typography variant="h4" className={''}>
                  <Skeleton width={60} />
                </Typography>
              </CardContent>
            </Card>

            <Card elevation={0}>
              <CardHeader subheader="Total impressions" />
              <CardContent sx={{ paddingTop: 0 }}>
                <Typography variant="h4" className={''}>
                  <Skeleton width={60} />
                </Typography>
              </CardContent>
            </Card>
          </Stack>
          <Stack spacing={0}>
            <Card elevation={0} variant="outlined">
              <CardHeader
                sx={{ py: 1 }}
                title={<Typography variant="subtitle">Last 5m</Typography>}
                subheader={<Skeleton width={55} />}
                action={
                  <IconButton>
                    <Skeleton
                      sx={{ marginLeft: 'auto' }}
                      height={24}
                      width={24}
                      variant="circular"
                    />
                  </IconButton>
                }
              />
            </Card>
            <Card elevation={0} variant="outlined">
              <CardHeader
                sx={{ py: 1 }}
                title={<Typography variant="subtitle">Last 24h</Typography>}
                subheader={<Skeleton width={55} />}
                action={
                  <IconButton>
                    <Skeleton
                      sx={{ marginLeft: 'auto' }}
                      height={24}
                      width={24}
                      variant="circular"
                    />
                  </IconButton>
                }
              />
            </Card>
          </Stack>
        </Stack>
      </CardContent>

      <CardContent className={styles.overviewChartArea}>
        <Stack direction={'row'} justifyContent="space-between">
          <Typography variant="caption">Good UX</Typography>
          <Typography variant="caption">Impressions</Typography>
        </Stack>
        <Skeleton width="100%" height={250} />
      </CardContent>

      <CardContent>
        <Typography variant="h6">
          Latest URLs with issues
          <Skeleton
            sx={{
              marginLeft: 'auto',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
            height={40}
            width={40}
            variant="circular"
          />
        </Typography>
        <UrlTable>{lazyList}</UrlTable>;
      </CardContent>
    </Card>
  );
}
